import { NationalApplication } from "../../NationalApplication";
import "./config";
import "./theme.css";

export default NationalApplication;
